<template>
  <div 
    class="fill-height mt-3">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                :disabled="process.form"
                width="120"
                filled
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                filled
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      <v-dialog v-model="dialog.form"
        v-if="dialog.form"
        @keydown.esc="dialog.form = false"
        :fullscreen="dialog.fullscreen"
        width="800"
        persistent
        scrollable>
        <v-card 
          :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
          <v-card-title 
            class="d-flex align-center pa-4 text-right popup-header">
            <div
              class="fs-17 font-weight-bold">
              {{ form.id === '' ? 'Tambah' : 'Ubah' }}
            </div>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              :color="set_color">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.form = false; dialog.fullscreen = false;"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>
          
          <v-divider 
            class="mb-2"
            style="border-top: 2px dashed #e0e0e0;"/>

          <v-card-text 
            class="py-0 my-4">
            <ValidationObserver 
              ref="form">
              <v-form>
                <v-card 
                  flat
                  class="mb-5"
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-card-text>
                    <div class="fs-16 font-weight-bold black_one mb-6">
                      Informasi Layanan
                    </div>
                    <v-row>
                      <v-col class="py-0" cols="12">
                        <div class="mb-2">
                          <ValidationProvider
                            :name="`Nama`" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2">
                              <span class="red--text">*</span>
                              Nama
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              rounded
                              dense
                              filled
                              hide-details
                              autofocus

                              :color="set_color"
                              placeholder="Nama"
                              :error-messages="errors"

                              v-model="form.name"
                              
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.name !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </div>
                      </v-col>
                      <v-col class="py-0" cols="6">
                        <div class="mb-2">
                          <ValidationProvider
                            :name="`Satuan`" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2">
                              <span class="red--text">*</span>
                              Satuan
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Pilih Satuan"

                              hide-details
                              clearable

                              :items="satuan"
                              item-text="name"
                              item-value="name"
                              :item-color="set_color"

                              v-model="form.satuan"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.satuan !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </div>
                      </v-col>
                      <v-col class="py-0" cols="6" v-if="form.par_id === '0' || form.par_id === ''">
                        <div class="mb-2">
                          <ValidationProvider
                            :name="`Kategori`" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2">
                              <span class="red--text">*</span>
                              Kategori
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Pilih Kategori"

                              hide-details
                              clearable

                              :items="category"
                              item-text="name"
                              item-value="id"
                              :item-color="set_color"

                              v-model="form.category_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.category_id !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </div>
                      </v-col>
                      <v-col class="py-0" cols="6">
                        <div class="mb-6">
                          <ValidationProvider
                            :name="`Durasi Layanan`" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2">
                              <span class="red--text">*</span>
                              Durasi Layanan
                            </div>

                            <v-currency-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Durasi Layanan"
                              :error-messages="errors"
                              suffix=" Menit"

                              v-model="form.duration_minutes"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.duration_minutes !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card 
                  flat
                  class="mb-5"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text>
                    <div class="fs-16 font-weight-bold black_one mb-6">
                      Informasi Stok
                    </div>
                    <v-row>
                      <v-col class="py-0" cols="6">
                        <div class="mb-2">
                          <!-- <ValidationProvider
                            :name="`Stok Minimal`" 
                            rules="required" 
                            v-slot="{ errors, valid }"> -->
                            <div class="mb-2">
                              <!-- <span class="red--text">*</span> -->
                              Stok Minimal
                            </div>

                            <v-currency-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Stok Minimal"

                              v-model="form.stock_min"
                              style="border-radius: 10px;">
                              <!-- <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.stock_min !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template> -->
                            </v-currency-field>
                          <!-- </ValidationProvider> -->
                        </div>
                      </v-col>
                      <v-col class="py-0" cols="6">
                        <!-- <ValidationProvider
                            :name="`Stok`" 
                            rules="required" 
                            v-slot="{ errors, valid }"> -->
                            <div class="mb-2">
                              <!-- <span class="red--text">*</span> -->
                              Stok
                            </div>

                            <v-currency-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Stok"

                              v-model="form.stock"
                              style="border-radius: 10px;">
                              <!-- <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.stock !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template> -->
                            </v-currency-field>
                          <!-- </ValidationProvider> -->
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card 
                  flat
                  class="mb-5"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text>
                    <div class="fs-16 font-weight-bold black_one mb-6">
                      Informasi Harga
                    </div>
                    <v-row>
                      <v-col class="py-0" cols="6">
                        <div class="mb-2">
                          <!-- <ValidationProvider
                            :name="`Harga Beli`" 
                            rules="required|min_value:0" 
                            v-slot="{ errors, valid }"> -->
                            <div class="mb-2">
                              <!-- <span class="red--text">*</span> -->
                              Harga Beli
                            </div>

                            <v-currency-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Harga Beli"

                              v-model="form.hpp"
                              style="border-radius: 10px;">
                              <!-- <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.hpp !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template> -->
                            </v-currency-field>
                          <!-- </ValidationProvider>  -->
                        </div>
                      </v-col>
                      <v-col class="py-0" cols="6">
                        <ValidationProvider
                            :name="`Harga Jual`" 
                            rules="required|min_value:0" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2">
                              <span class="red--text">*</span>
                              Harga Jual
                            </div>

                            <v-currency-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Harga Jual"
                              :error-messages="errors"

                              v-model="form.selling_price"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.selling_price !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                      </v-col>
                    </v-row>
                    <div v-if="user.is_count_ppn === '1'">
                      <div>
                        <v-checkbox v-model="form.is_ppn">
                          <template v-slot:label>
                            <div class="black--text">
                              Gunakan PPN
                            </div>
                          </template>
                        </v-checkbox>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                <v-card 
                  flat
                  class="mb-5"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text>
                    <div class="fs-16 font-weight-bold black_one mb-6">
                      Informasi Diskon
                    </div>
                    <v-row>
                      <v-col class="py-0" cols="6">
                        <div class="mb-2">
                          <ValidationProvider
                            :name="`Diskon`" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2">
                              <span class="red--text">*</span>
                              Diskon
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              v-on:change="form.discount_type === 'tidak' ? form.discount_value = 0 : ''; form.discount_type === 'tidak' ? form.discount_percent = 0 : ''"

                              :color="set_color"
                              placeholder="Pilih Diskon"

                              hide-details
                              clearable

                              :items="[{
                                id: 'tidak',
                                name: 'Tiada Diskon'
                              }, {
                                id: 'persen',
                                name: 'Persen'
                              }, {
                                id: 'rupiah',
                                name: 'Rupiah'
                              }
                              ]"
                              item-text="name"
                              item-value="id"
                              v-model="form.discount_type"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.discount_type !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-select>
                          </ValidationProvider>
                        </div>
                      </v-col>
                      <v-col class="py-0" cols="6" v-if="form.discount_type === 'persen'">
                        <ValidationProvider
                            :name="`Diskon (Persen)`" 
                            rules="required|min_value:0|max_value:100" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2">
                              <span class="red--text">*</span>
                              Diskon (Persen)
                            </div>

                            <v-currency-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Diskon (Persen)"
                              :error-messages="errors"
                              suffix=" %"
                              :auto-decimal-mode="false"
                              :decimal-length="2"

                              v-model="form.discount_percent"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.discount_percent !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                      </v-col>
                      <v-col class="py-0" cols="6" v-if="form.discount_type === 'rupiah'">
                        <ValidationProvider
                          :name="`Diskon (Rupiah)`" 
                          :rules="`required|min_value:0|max_value_price:${form.selling_price}`" 
                          v-slot="{ errors, valid }">
                          <div class="mb-2">
                            <span class="red--text">*</span>
                            Diskon (Rupiah)
                          </div>

                          <v-currency-field
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense
                            prefix="Rp. "

                            :color="set_color"
                            placeholder="Diskon (Rupiah)"
                            :error-messages="errors"

                            v-model="form.discount_value"
                            required
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  {{ errors[0] }}
                                </v-tooltip>
                              </div>
                              
                              <div v-if="form.discount_value !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-currency-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card 
                  flat
                  class="mb-5"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text>
                    <div class="fs-16 font-weight-bold black_one mb-6">
                      <!-- <span class="red--text">*</span> -->
                      Deskripsi Layanan
                    </div>

                    <ValidationProvider
                      :name="`Deskripsi`" 
                      rules="" 
                      v-slot="{ errors, valid }">

                      <v-textarea
                        v-on:keyup.enter="save()"
                        
                        filled
                        rounded
                        dense

                        :color="set_color"
                        placeholder="Deskripsi"
                        :error-messages="errors"
                        rows="3"

                        v-model="form.desc"
                        required
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>
                          
                          <div v-if="form.desc !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-textarea>
                    </ValidationProvider>
                  </v-card-text>
                </v-card>

                <v-card 
                  flat
                  class="mb-5"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text>
                    <div class="fs-16 font-weight-bold black_one mb-6">
                      Gambar Layanan
                    </div>
                    <v-row>
                      <v-col class="py-0" cols="12">
                        <uploadfolder
                          v-model="upload.image" 
                          style="height: 250px; width: 250px">
                          <div 
                            slot="activator"
                            class="cursor-pointer">
                            <v-card 
                              flat
                              height="250"
                              class="d-flex align-center justify-center"
                              style="border-radius: 15px;
                                    border: 2px solid #eaeaea; 
                                    border-style: dashed;">
                              <div v-if="form.image_url.length < 1">
                                <v-icon v-if="!process.image"
                                  size="60" 
                                  color="#718EBF">
                                  mdi-cloud-upload-outline
                                </v-icon>
        
                                <v-progress-circular v-else
                                  indeterminate
                                  :color="set_color">
                                </v-progress-circular>
                              </div>
        
                              <v-img v-else
                                contain
                                height="250"
                                :src="form.image_url" 
                                :alt="form.image_url"
                                class="text-center d-flex align-center">
                                <div 
                                  class="d-flex aling-center justify-center" 
                                  style="width: 100%; height: auto;">
                                  <v-icon v-if="!process.image"
                                    size="60" 
                                    color="white">
                                    mdi-cloud-upload-outline
                                  </v-icon>
        
                                  <v-progress-circular v-else
                                    indeterminate
                                    :color="set_color">
                                  </v-progress-circular>
                                </div>
                              </v-img>
                            </v-card>
                          </div>
                        </uploadfolder>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-form>
            </ValidationObserver>

            <!-- <div v-if="message.error.length > 0"
              class="text-center mt-6">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div> -->
          </v-card-text>
          
          <v-divider 
            class="mt-2"
            style="border-top: 2px dashed #e0e0e0;"/>

          <v-card-actions
            class="pa-4">
            <div v-if="message.error.length > 0"
              class="text-left mt-6">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>
            <v-spacer/>

            <v-btn
              @click="save(); form.id == '' ? selected_par_id = '0' : '';"
              :loading="process.form"
              :disabled="process.form"
              width="120"
              elevation="0"
              color="green"
              rounded
              class="body-2 font-weight-bold text-capitalize white--text">
              Simpan
            </v-btn>

            <v-btn
              @click="dialog.form = false; reset();"
              :disabled="process.form"
              width="120"
              filled
              elevation="0"
              color="red"
              rounded
              class="body-2 font-weight-bold text-capitalize white--text">
              Batal
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog.formSub"
        v-if="dialog.formSub"
        @keydown.esc="dialog.formSub = false"
        :fullscreen="dialog.fullscreen"
        width="800"
        persistent
        scrollable>
        <v-card 
          :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
          <v-card-title 
            class="d-flex align-center pa-4 text-right popup-header">
            <div
              class="fs-17 font-weight-bold">
              {{ form.id === '' ? 'Tambah' : 'Ubah' }} Sub di {{ name_parent }}
            </div>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              :color="set_color">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.formSub = false; dialog.fullscreen = false;"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>
          
          <v-divider 
            class="mb-2"
            style="border-top: 2px dashed #e0e0e0;"/>

          <v-card-text 
            class="py-0 my-4">
            <ValidationObserver 
              ref="form">
              <v-form>
                <v-card 
                  flat
                  class="mb-5"
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-card-text>
                    <div class="fs-16 font-weight-bold black_one mb-6">
                      Informasi Layanan
                    </div>
                    <v-row>
                      <v-col class="py-0" cols="12">
                        <div class="mb-2">
                          <ValidationProvider
                            :name="`Nama`" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2">
                              <span class="red--text">*</span>
                              Nama
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              rounded
                              dense
                              filled
                              hide-details
                              autofocus

                              :color="set_color"
                              placeholder="Nama"
                              :error-messages="errors"

                              v-model="form.name"
                              
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.name !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </div>
                      </v-col>
                      <v-col class="py-0" cols="6">
                        <div class="mb-2">
                          <ValidationProvider
                            :name="`Satuan`" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2">
                              <span class="red--text">*</span>
                              Satuan
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Pilih Satuan"

                              hide-details
                              clearable

                              :items="satuan"
                              item-text="name"
                              item-value="name"
                              :item-color="set_color"

                              v-model="form.satuan"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.satuan !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </div>
                      </v-col>

                      <v-col class="py-0" cols="6">
                        <div class="mb-6">
                          <ValidationProvider
                            :name="`Durasi Layanan`" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2">
                              <span class="red--text">*</span>
                              Durasi Layanan
                            </div>

                            <v-currency-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Durasi Layanan"
                              :error-messages="errors"
                              suffix=" Menit"

                              v-model="form.duration_minutes"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.duration_minutes !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card 
                  flat
                  class="mb-5"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text>
                    <div class="fs-16 font-weight-bold black_one mb-6">
                      Informasi Stok
                    </div>
                    <v-row>
                      <v-col class="py-0" cols="6">
                        <div class="mb-2">
                          <!-- <ValidationProvider
                            :name="`Stok Minimal`" 
                            rules="required" 
                            v-slot="{ errors, valid }"> -->
                            <div class="mb-2">
                              <!-- <span class="red--text">*</span> -->
                              Stok Minimal
                            </div>

                            <v-currency-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Stok Minimal"

                              v-model="form.stock_min"
                              style="border-radius: 10px;">
                              <!-- <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.stock_min !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template> -->
                            </v-currency-field>
                          <!-- </ValidationProvider> -->
                        </div>
                      </v-col>
                      <v-col class="py-0" cols="6">
                        <!-- <ValidationProvider
                            :name="`Stok`" 
                            rules="required" 
                            v-slot="{ errors, valid }"> -->
                            <div class="mb-2">
                              <!-- <span class="red--text">*</span> -->
                              Stok
                            </div>

                            <v-currency-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Stok"

                              v-model="form.stock"
                              style="border-radius: 10px;">
                              <!-- <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.stock !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template> -->
                            </v-currency-field>
                          <!-- </ValidationProvider> -->
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card 
                  flat
                  class="mb-5"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text>
                    <div class="fs-16 font-weight-bold black_one mb-6">
                      Informasi Harga
                    </div>
                    <v-row>
                      <v-col class="py-0" cols="6">
                        <div class="mb-2">
                          <!-- <ValidationProvider
                            :name="`Harga Beli`" 
                            rules="required|min_value:0" 
                            v-slot="{ errors, valid }"> -->
                            <div class="mb-2">
                              <!-- <span class="red--text">*</span> -->
                              Harga Beli
                            </div>

                            <v-currency-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Harga Beli"

                              v-model="form.hpp"
                              style="border-radius: 10px;">
                              <!-- <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.hpp !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template> -->
                            </v-currency-field>
                          <!-- </ValidationProvider>  -->
                        </div>
                      </v-col>
                      <v-col class="py-0" cols="6">
                        <ValidationProvider
                            :name="`Harga Jual`" 
                            rules="required|min_value:0" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2">
                              <span class="red--text">*</span>
                              Harga Jual
                            </div>

                            <v-currency-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Harga Jual"
                              :error-messages="errors"

                              v-model="form.selling_price"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.selling_price !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                      </v-col>
                    </v-row>
                    <div v-if="user.is_count_ppn === '1'">
                      <div>
                        <v-checkbox v-model="form.is_ppn">
                          <template v-slot:label>
                            <div class="black--text">
                              Gunakan PPN
                            </div>
                          </template>
                        </v-checkbox>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                <v-card 
                  flat
                  class="mb-5"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text>
                    <div class="fs-16 font-weight-bold black_one mb-6">
                      Informasi Diskon
                    </div>
                    <v-row>
                      <v-col class="py-0" cols="6">
                        <div class="mb-2">
                          <ValidationProvider
                            :name="`Diskon`" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2">
                              <span class="red--text">*</span>
                              Diskon
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              v-on:change="form.discount_type === 'tidak' ? form.discount_value = 0 : ''; form.discount_type === 'tidak' ? form.discount_percent = 0 : ''"

                              :color="set_color"
                              placeholder="Pilih Diskon"

                              hide-details
                              clearable

                              :items="[{
                                id: 'tidak',
                                name: 'Tiada Diskon'
                              }, {
                                id: 'persen',
                                name: 'Persen'
                              }, {
                                id: 'rupiah',
                                name: 'Rupiah'
                              }
                              ]"
                              item-text="name"
                              item-value="id"
                              v-model="form.discount_type"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.discount_type !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-select>
                          </ValidationProvider>
                        </div>
                      </v-col>
                      <v-col class="py-0" cols="6" v-if="form.discount_type === 'persen'">
                        <ValidationProvider
                            :name="`Diskon (Persen)`" 
                            rules="required|min_value:0|max_value:100" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2">
                              <span class="red--text">*</span>
                              Diskon (Persen)
                            </div>

                            <v-currency-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Diskon (Persen)"
                              :error-messages="errors"
                              suffix=" %"
                              :auto-decimal-mode="false"
                              :decimal-length="2"

                              v-model="form.discount_percent"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.discount_percent !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                      </v-col>
                      <v-col class="py-0" cols="6" v-if="form.discount_type === 'rupiah'">
                        <ValidationProvider
                          :name="`Diskon (Rupiah)`" 
                          :rules="`required|min_value:0|max_value_price:${form.selling_price}`" 
                          v-slot="{ errors, valid }">
                          <div class="mb-2">
                            <span class="red--text">*</span>
                            Diskon (Rupiah)
                          </div>

                          <v-currency-field
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense
                            prefix="Rp. "

                            :color="set_color"
                            placeholder="Diskon (Rupiah)"
                            :error-messages="errors"

                            v-model="form.discount_value"
                            required
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  {{ errors[0] }}
                                </v-tooltip>
                              </div>
                              
                              <div v-if="form.discount_value !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-currency-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card 
                  flat
                  class="mb-5"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text>
                    <div class="fs-16 font-weight-bold black_one mb-6">
                      <span class="red--text">*</span>
                      Deskripsi Layanan
                    </div>

                    <ValidationProvider
                      :name="`Deskripsi`" 
                      rules="" 
                      v-slot="{ errors, valid }">

                      <v-textarea
                        v-on:keyup.enter="save()"
                        
                        filled
                        rounded
                        dense

                        :color="set_color"
                        placeholder="Deskripsi"
                        :error-messages="errors"
                        rows="3"

                        v-model="form.desc"
                        required
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>
                          
                          <div v-if="form.desc !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-textarea>
                    </ValidationProvider>
                  </v-card-text>
                </v-card>

                <v-card 
                  flat
                  class="mb-5"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text>
                    <div class="fs-16 font-weight-bold black_one mb-6">
                      Gambar Layanan
                    </div>
                    <v-row>
                      <v-col class="py-0" cols="12">
                        <uploadfolder
                          v-model="upload.image" 
                          style="height: 250px; width: 250px">
                          <div 
                            slot="activator"
                            class="cursor-pointer">
                            <v-card 
                              flat
                              height="250"
                              class="d-flex align-center justify-center"
                              style="border-radius: 15px;
                                    border: 2px solid #eaeaea; 
                                    border-style: dashed;">
                              <div v-if="form.image_url.length < 1">
                                <v-icon v-if="!process.image"
                                  size="60" 
                                  color="#718EBF">
                                  mdi-cloud-upload-outline
                                </v-icon>
        
                                <v-progress-circular v-else
                                  indeterminate
                                  :color="set_color">
                                </v-progress-circular>
                              </div>
        
                              <v-img v-else
                                contain
                                height="250"
                                :src="form.image_url" 
                                :alt="form.image_url"
                                class="text-center d-flex align-center">
                                <div 
                                  class="d-flex aling-center justify-center" 
                                  style="width: 100%; height: auto;">
                                  <v-icon v-if="!process.image"
                                    size="60" 
                                    color="white">
                                    mdi-cloud-upload-outline
                                  </v-icon>
        
                                  <v-progress-circular v-else
                                    indeterminate
                                    :color="set_color">
                                  </v-progress-circular>
                                </div>
                              </v-img>
                            </v-card>
                          </div>
                        </uploadfolder>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-form>
            </ValidationObserver>

          </v-card-text>
          
          <v-divider 
            class="mt-2"
            style="border-top: 2px dashed #e0e0e0;"/>

          <v-card-actions
            class="pa-4">
            <div v-if="message.error.length > 0"
              class="text-left mt-6">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>
            <v-spacer/>

            <v-btn
              @click="save()"
              :loading="process.form"
              :disabled="process.form"
              width="120"
              elevation="0"
              color="green"
              rounded
              class="body-2 font-weight-bold text-capitalize white--text">
              Simpan
            </v-btn>

            <v-btn
              @click="dialog.formSub = false; reset();"
              :disabled="process.form"
              width="120"
              filled
              elevation="0"
              color="red"
              rounded
              class="body-2 font-weight-bold text-capitalize white--text">
              Batal
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

        <section>
          <v-card
            flat
            color="transparent">
            <div
              class="d-flex align-center px-2">
              <div
                class="d-flex align-center">
                <v-avatar
                  tile
                  size="22">
                  <v-img
                    contain
                    alt="POS Amanata"  
                    :src="require('@/assets/image/grip_menu.png')">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <span
                  class="fs-16 black--text ml-2"
                  style="font-weight: 600;">
                  Layanan
                </span>
              </div>

              <v-spacer />

            </div>
          </v-card>

          <v-row
            justify="end"
            class="pa-3 py-0 pr-1">
            <!-- <v-col cols="7">
              <div
                class="d-flex align-center">
                <v-avatar
                  tile
                  size="30">
                  <v-img
                    contain
                    alt="POS Amanata"  
                    :src="require('@/assets/image/grip_menu.png')">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <span
                  class="title black--text ml-2"
                  style="font-weight: 600;">
                  Satuan
                </span>
              </div>
            </v-col> -->
            <v-col
              cols="12"
              md="12"
              class="d-flex align-center pb-0">

              <!-- <div>
                    <v-btn
                      to="/master-penjualan/product/add"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </div> -->

              <div v-if="child.length === 1">
                <v-btn
                  @click="dialog.form = true; reset();"
                  color="#4B4B4B"
                  elevation="0"
                  small
                  min-height="30"
                  class="fs-12 white--text text-capitalize d-flex align-center"
                  style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                  <v-icon size="18">mdi-plus-circle-multiple</v-icon>
                  
                  <span
                    class="ml-2">
                    Tambah
                  </span>
                </v-btn>
              </div>
              <div v-if="child.length > 1">
                <v-btn
                  @click="dialog.formSub = true; resetSub(child[child.length-1], undefined);"
                  color="primary"
                  elevation="0"
                  small
                  min-height="30"
                  class="fs-12 white--text text-capitalize d-flex align-center"
                  style="border-radius: 6px; font-weight: 600;">
                  <v-icon size="18">mdi-plus-circle-multiple</v-icon>
                  
                  <span
                    class="ml-2">
                    Tambah Sub
                  </span>
                </v-btn>
              </div>
              <v-text-field
                @click:clear="selected_par_id = '0'; search = ''; fetch();"
                v-on:keyup.enter="toSearch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                class="ml-3 fs-12 little-placeholder"
                style="border-radius: 6px; width: 320px; min-width: 320px; max-width: 320px;">
              </v-text-field>

              <!-- FILTER -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      filled
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.filter = true">
                      <v-icon size="18">mdi-filter-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Filter
                  </span>
                </v-tooltip>
              </div> -->

              <!-- FREEZE COLUMN -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="30"
                      small
                      min-height="30"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 6px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.freeze = true">
                      <v-icon size="18">mdi-table-split-cell</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Freeze
                  </span>
                </v-tooltip>
              </div> -->

              <!-- HIDE COLUMN -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="30"
                      small
                      min-height="30"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 6px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.hide = true">
                      <v-icon size="18">mdi-eye-off-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Hide
                  </span>
                </v-tooltip>
              </div> -->
            </v-col>
          </v-row>

          <div class="px-4 pt-2 d-flex align-center" v-if="child.length > 1">
            <div v-for="(item, index) in child" :key="index" class="fs-12" :class="item.link == true ? 'color: primary--text' : ''" @click="item.link === true ? toLink(item, index) : ''" style="cursor: pointer">
              {{ item.name }}
              <span v-if="index < child.length - 1" class="mx-2">></span>
            </div>
          </div>

          <v-row
            class="pa-4 pr-1 pb-0 pt-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
              flat
              style="border-radius: 10px; border: 1px solid #E7E7E7;">
              <v-card-text class="pa-0">
                <div class="view">
                  <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper-pegawai'">
                    <table style="border-radius: 10px; width: 100%;" class="table">
                      <tr>
                        <th :style="`background-color: ${set_color}; color: #fff;`" class="sticky-col one-col" style="z-index: 1;  color: white; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'name' ? toSort('name') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Nama
                          <span v-if="sortBy === 'name'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <!-- <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'type' ? toSort('type') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Type
                          <span v-if="sortBy === 'type'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th> -->
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'category_name' ? toSort('category_name') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Kategori
                          <span v-if="sortBy === 'category_name'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'selling_price' ? toSort('selling_price') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">
                          Harga Jual
                          <span v-if="sortBy === 'selling_price'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'hpp' ? toSort('hpp') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">
                          Harga Beli
                          <span v-if="sortBy === 'hpp'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'discount_percent' ? toSort('discount_percent') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">
                          Diskon Persen
                          <span v-if="sortBy === 'discount_percent'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'discount_value' ? toSort('discount_value') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">
                          Diskon Nominal
                          <span v-if="sortBy === 'discount_value'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'stock' ? toSort('stock') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Stok
                          <span v-if="sortBy === 'stock'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'stock_min' ? toSort('stock_min') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Min. Stok
                          <span v-if="sortBy === 'stock_min'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <!-- <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Realisasi</th>
                        <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Selisih</th> -->
                      </tr>
                      <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                        <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 200px; min-width: 200px; max-width: 200px; padding: 8px 12px; text-align: center;">
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :to="`/master-penjualan/layanan/detail/${item.id}`"
                                
                                v-bind="attrs"
                                v-on="on"
                                
                                min-width="24"
                                min-height="24"
                                x-small
                                rounded
                                color="indigo"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="15">mdi-information-slab-circle-outline</v-icon>
                              </v-btn>
                            </template>
    
                            <span>Detail</span>
                          </v-tooltip>

                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                min-width="24"
                                min-height="24"
                                x-small
                                rounded
                                @click="dialog.formSub = true; resetSub(item, undefined);"
                                color="green"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="15">mdi-plus-circle</v-icon>
                                
                              </v-btn>
                            </template>
    
                            <span>Tambah</span>
                          </v-tooltip>

                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="dialog.form = true; reset(item);"
                                
                                v-bind="attrs"
                                v-on="on"
                                min-width="24"
                                min-height="24"
                                x-small
                                rounded
                                color="blue"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="15">mdi-square-edit-outline</v-icon>
                                
                              </v-btn>
                            </template>

                            <span>Ubah</span>
                          </v-tooltip>
                          <v-tooltip 
                            top v-if="!item.is_child">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                @click="toDelete(item.id);"
                                min-width="24"
                                min-height="24"
                                x-small
                                rounded
                                color="red"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="15">mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </template>

                            <span>Hapus</span>
                          </v-tooltip>
                          <v-tooltip 
                            top
                            v-if="item.is_child">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                @click="toSubproduk(item)"
                                min-width="24"
                                min-height="24"
                                x-small
                                rounded
                                color="#00695C"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="15">mdi-file-tree</v-icon>
                              </v-btn>
                            </template>

                            <span>Sub Produk</span>
                          </v-tooltip>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;">{{ item.name }}</td>
                        <!-- <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;">{{ item.type }}</td> -->
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150px; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;">{{ item.category_name }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150px; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: right;">
                          <span v-if="item.is_child">-</span>
                          <span v-else>
                            {{ item.selling_price | price }}
                          </span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150px; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: right;">
                          <span v-if="item.is_child">-</span>
                          <span v-else>
                            {{ item.hpp | price }}
                          </span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150px; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: right;">
                          <span v-if="item.is_child">-</span>
                          <span v-else>
                            {{ item.discount_percent*1 }} %
                          </span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150px; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: right;">
                          <span v-if="item.is_child">-</span>
                          <span v-else>
                            {{ (item.discount_value*1) | price }}
                          </span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150px; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;">
                          <span v-if="item.is_child">-</span>
                          <span v-else>
                            {{ item.stock }}
                          </span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150px; width: 1px;  padding: 8px 12px; text-align: left;">
                          <span v-if="item.is_child">-</span>
                          <span v-else>
                            {{ item.stock_min }}
                          </span>
                        </td>
                        <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">{{ (item.realisasi*1) | price }}</td> -->
                        <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">
                          {{ ((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' :((item.nominal*1) + (item.nominal_sp2b*1)) > (item.realisasi*1) ? '-' : '+'}}
                          {{ (((item.nominal*1) + (item.nominal_sp2b*1)) - (item.realisasi*1)) | price }}
                        </td> -->
                      </tr>
                    </table>
                  </div>
    
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
    
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>
    
                  <v-card-text
                    v-if="!process.load && list.length === 0"
                    class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                        <!-- <template v-slot:placeholder>
                          <v-row
                            class=" "
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template> -->
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum Ada Data
                      </div>
                    </div>
                  </v-card-text>
    
                  <pagination v-if="!process.load && pagination.total_data > 0"
                    @changePage="fetch($event)" 
                    @reloadPage="fetch($event)" 
                    :model="pagination" :display="paginationList"/>
    
                </div>
              </v-card-text>
                <!-- <v-data-table
                  v-model="selected.row"
                  ref="table-grid"
                  class="table-grid"
                  :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '248px'})`"
                  :show-select="checkbox"
                  :single-select="true"
                  :loading="process.load"
                  loading-text="Sedang memuat data . . ."
                  loader-height="5"
                  no-results-text="Belum ada data"
                  :options.sync="options"
                  :headers="configHeaders"
                  :items="list"
                  :items-per-page="100"
                  item-key="id"
                  @click:row="rowClick"
                  @toggle-select-all="handleToggleAll($event)"
                  @dblclick:row="doubleClick"
                  hide-default-footer>
                  <template
                    v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                    v-slot:[`item.${header.value}`]="{ value }">
                    <div
                      v-bind:key="header.value">
                      <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                        {{ rowFormat(header.format, value) }} 
                      </div>

                      <div v-if="header.format === 'link'"
                        class="cursor-pointer">
                        
                      </div>
        
                      <div v-if="header.format === 'regex'">
                        <span
                          class="two-line">
                          {{ rowFormat(header.format, value) }}
                        </span>
                      </div>
        
                      <div v-if="header.format === 'image'"
                        class="ma-4">
                        <v-avatar
                          size="60"
                          tile
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <v-img 
                            contain
                            width="100%"
                            height="100%"
                            alt="POS Amanata" 
                            :src="value !== '' ? value : require('@/assets/image/member_default.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>

                      <div v-if="header.format === 'image_potrait'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="100"
                          height="125"
                          alt="POS Amanata" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'image_landscape'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="200"
                          height="125"
                          alt="POS Amanata" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'action'">
                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              :to="`/product/detail/${value}`"
                              
                              v-bind="attrs"
                              v-on="on"
                              
                              min-width="24" min-height="24"
                              small
                              rounded
                              color="green"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon size="15">mdi-information-slab-circle-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>Detail</span>
                        </v-tooltip>

                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              :to="`/product/edit/${value}`"
                              
                              v-bind="attrs"
                              v-on="on"

                              min-width="24" min-height="24"
                              small
                              rounded
                              color="blue"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon size="15">mdi-square-edit-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>Ubah</span>
                        </v-tooltip>

                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="toDelete(value)"

                              v-bind="attrs"
                              v-on="on"

                              min-width="24" min-height="24"
                              small
                              rounded
                              color="red"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon size="15">mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </template>
                          
                          <span>Hapus</span>
                        </v-tooltip>
                      </div>


                      <div v-if="header.format === 'status'"
                        class="d-flex justify-center">
                        
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`item.index`]="{ index }">
                    {{ lastIndex + index }}
                  </template>

                  <v-progress-linear 
                    v-show="process.load" 
                    slot="progress" 
                    color="white" 
                    indeterminate>
                  </v-progress-linear>
                </v-data-table> -->

                <!-- <pagination v-if="pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination" :display="paginationList"/> -->
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          checkbox: false,
          child: [
            {
              id: '0',
              name: 'Data Produk',
              link: true
            }
          ],

          selected_par_id: '0',
          sortBy: 'id',
          sortDesc: '-',
  
          dialog: {
            fullscreen: false,
            snackbar: false,
            freeze: false,
            hide: false,
  
            delete: false,
            reset: false,
            role: false,
  
            filter: false,
            form: false,
            formSub: false
          },
          
          search: '',
  
          filter: {
            
          },
  
          selected: {
            row: [],
            freeze: [],
            delete: [],
            reset: [],
            role: []
          },

          tree: [],
  
          role: [],
          paginationList: {},
  
          options: {},
          headers: [],
          list: [],
          pagination: {},
  
          lastIndex: 0,
          limit: 20,

          satuan: [],
          category: [],
  
          form: {
            outlet_id: '',
            par_id: '',

            category_id: '',
            satuan: '',
            name: '',
            type: '',
            image_url: '',
            stock: '',
            stock_min: '',
            selling_price: '',
            hpp: '',
            duration_minutes: '',
            discount_percent: '',
            discount_value: '',
            discount_type: 'tidak',
            is_ppn: false,
            desc: '',
          },
          upload: {
            image: null
          },
          name_parent: '',
          selected_list: 'parent',
  
          process: {
            load: true,
  
            delete: false,
            reset: false,
            role: false,
            image: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue'),
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
      },
      watch: {
        'upload.image': {
          handler: function () {
            if (this.upload.image) {
              this.process.image = this.upload.image.process

              if (!this.process.image) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.image_url = this.upload.image.fileuri

                // this.save_image()
              }
            }
          },
          deep: true
        },
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        user () {
        return this.$store.state.user
        },
        outlet () {
          return this.$store.state.outlet
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        }
      },
      mounted () {
        this.fetch()
        this.fetchCategory()
        this.fetchSatuan()
      },
      methods: {
        toSearch () {
          this.selected_list = this.child.length > 1 ? 'parent' : 'child'
          if (this.selected_list === 'parent') {
            this.fetch()
          } else {
            this.fetchLastChild()
          }
        },
        toSort(name) {
        this.sortBy = name
        this.sortDesc = ''
        // this.fetch()
        if (this.selected_list === 'parent') {
          this.fetch()
        } else {
          this.fetchLastChild()
        }
      },
      toDesc() {
        this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
        if (this.selected_list === 'parent') {
          this.fetch()
        } else {
          this.fetchLastChild()
        }
      },
      toSubproduk (item) {
        this.child[this.child.length - 1].link = true
        this.child.push({
          id: item.id,
          name: item.name,
          link: false,
          category_id: item.category_id
        })
        this.selected_par_id = item.id
        this.search = ''
        this.fetch()
      },
      toLink (item, index) {
        this.child.splice(index + 1, this.child.length - index)
        this.child[this.child.length - 1].link = false
        this.selected_par_id = item.id
        this.search = ''
        this.fetch()
        
      },
        rowFormat (format, value) {
          let data = value
  
          if (format === 'number') {
            if (isNaN(value)) return 'Not a Number'
            let price = ''
  
            const reverseNumber = value
              .toString()
              .split('')
              .reverse()
              .join('')
            const arrReverseNumber = [...Array(reverseNumber.length).keys()]
  
            arrReverseNumber.map(index => {
              if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
            })
  
            return `Rp ${
              price.split('', price.length - 1)
              .reverse()
              .join('')
            }`
          } else if (format === 'array') {
            let arr = []
  
            for (let i = 0; i < value.length; i++) {
              arr.push(value[i].label)
            }
  
            data = arr.join(', ')
          } else if (format === 'date') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
          } else if (format === 'time') {
            data = value.length > 0 ? moment(value).format('HH:mm') : '-'
          } else if (format === 'datetime') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          } else if (format === 'object') {
            data = value.createdby.name
          } else if (format === 'regex') {
            let regex = /(<([^>]+)>)/ig
  
            data = value.replace(regex, '')
          } else if (format === 'underscore') {
            let regex = /_/g
  
            data = value.replace(regex, ' ')
          } else if (format === 'on_off') {
            data = value ? 'Online' : 'Offline'
          } else if (format === 'g_m') {
            data = value ? 'Mandiri' : 'Group'
          } else if (format === 'v_a') {
            data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
          } else if (format === 'y_n') {
            data = parseInt(value) ? 'Ya' : 'Tidak'
          } else if (format === 'percent') {
            data = Number(value) + ' %'
          } else if (format === 'action') {
            data = value
          } else if (format === 'bool') {
            data = value
          } else if (format === 'status') {
            data = value
          } else if (format === 'link') {
            data = value
          }  else {
            data = value ? 'Aktif' : 'Tidak Aktif'
          }
  
          return data
        },
        rowClick (item, row) {
          row.select(!row.isSelected ? true : false)
        },
        doubleClick (event, {item}) {
          // NO ACTION
        },
        handleToggleAll (event) {
          if (!event.value) this.selected.row = []
        },

        async fetchCategory (data) {
          let params = {
            outlet_id: this.outlet.outlet_id,
            limit: 1000000000,
            is_active: '1',
            type: 'layanan'
          }
          
          await get('pos/category/data', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.category = res.results.data
            }
          })
        },
        async fetchSatuan (data) {
          let params = {
            // outlet_id: this.outlet.outlet_id,
            limit: 1000000000
          }
          
          await get('pos/satuan/data', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.satuan = res.results.data
            }
          })
        },
  
        async fetch (pagination = { row: 20, page: 1 }) {
          this.process.load = true
          
          this.limit = pagination.row
          this.paginationList = pagination
          
          let params = {
            sort: `${this.sortDesc}${this.sortBy}`,
            par_id: this.selected_par_id,
            limit: pagination.row,
            page: pagination.page,
            // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
            outlet_id: this.outlet.outlet_id,
            search: this.search,
            type: 'layanan'
          }
  
          // this.selected.row = []
  
          await get(`pos/item_sales/data`, { params })
          .then(response => {
            console.log(this.$store.state.user)
            let res = response.data
  
            this.process.load = false
  
            this.list = []
            this.pagination = {}
              
            if (res.status === 200) {
              this.headers = [
                {
                  text: 'Aksi',
                  // width: '180px',
                  value: 'id',
                  freeze: true,
                  hide: false,
                  align: 'center',
                  format: 'action'
                },
                // {
                //   text: 'Nomor Induk Pegawai',
                //   width: '200px',
                //   value: 'nip',
                //   freeze: false,
                //   hide: false
                // },
                {
                  text: 'Nama Lengkap',
                  width: '300px',
                  value: 'name',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Email',
                  width: '200px',
                  value: 'email',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Telepon',
                  width: '200px',
                  value: 'mobilephone',
                  freeze: false,
                  hide: false
                },
                // {
                //   text: 'Jenis Kelamin',
                //   width: '200px',
                //   value: 'gender',
                //   freeze: false,
                //   hide: false
                // },
                {
                  text: 'Nama Outlet',
                  width: '400px',
                  value: 'outlet_name',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Role',
                  width: '200px',
                  value: 'cat_title',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Dibuat Tanggal',
                  width: '200px',
                  value: 'input_datetime',
                  freeze: false,
                  hide: false,
                  format: 'datetime'
                }
              ]
  
              this.list = res.results.data
              this.pagination = res.results.pagination
              if (this.selected_par_id === '0') {
                this.child = [
                  {
                    id: '0',
                    name: 'Data Produk',
                    link: true
                  }
                ]
              }
  
              // this.list.map(obj => {
              //   obj.is_active = obj.is_active === '1' ? true : false
              // })
  
              // this.lastIndex = (pagination.page - 1) * pagination.row 
              // this.lastIndex += 1
  
              // this.addFreezes()
  
              // this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
  
              // if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            }
          })
        },

        async fetchLastChild (pagination = { row: 20, page: 1 }) {
          this.process.load = true
          
          this.limit = pagination.row
          this.paginationList = pagination
          
          let params = {
            // pagination_bool: false,
            // sort: '-id',
            search: this.search,
            sort: `${this.sortDesc}${this.sortBy}`,
            // par_id: '0',

            par_id: this.selected_par_id === '0' ? '' : this.selected_par_id,
            // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
            outlet_id: this.outlet.outlet_id,
            // search: this.search,
            type: 'layanan'
          }
  
          // this.selected.row = []
  
          await get(`pos/item_sales/data`, { params })
          .then(response => {
            // console.log(this.$store.state.user)
            let res = response.data
  
            this.process.load = false
  
            this.list = []
            this.pagination = {}
              
            if (res.status === 200) {
  
              this.list = res.results.data
              this.pagination = res.results.pagination
              if (this.selected_par_id === '0') {
                this.child = [
                  {
                    id: '0',
                    name: 'Data Produk',
                    link: true
                  }
                ]
              }
  
            }
          })
        },
  
        addFreezes () {
          this.removeFreezes()
  
          this.selected.freeze = []
  
          for (let i = 0; i < this.configHeaders.length; i++) {
            if (this.configHeaders[i].freeze) {
              // ADD TO SELECTOR
              this.selected.freeze.push({
                child: i + (this.checkbox ? 2 : 1),
                width: this.configHeaders[i].width.split('px')[0]
              })
  
              // LOOP STYLESHEET
              for (let f = 0; f < this.selected.freeze.length; f++) {
                let style = document.createElement('style'),
                    width = 0
  
                if (this.checkbox) {
                  width = f < 1 ? '65' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
                } else {
                  width = f < 1 ? '0' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
                }
  
                // ADD STYLESHET TO FREEZE
                style.innerHTML = `
                  .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 5;
                    background: #FFFFFF;
                  }
  
                  .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 1;
                  }
                `
  
                // ADD TO APPENDCHILD
                document.head.appendChild(style)
              }
            }
          }
        },
        removeFreezes () {
          // LOOP STYLESHEET
          for (let f = 0; f < this.selected.freeze.length; f++) {
            let style = document.createElement('style')
            
            // RESET STYLESHEET TO AUTO
            style.innerHTML = `
              .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
                background: #FFFFFF;
              }
  
              .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
              }
            `
  
            // ADD TO APPENDCHILD
            document.head.appendChild(style)
          }
        },
        addHides () {
          if (this.headers.length < 6) this.getTableToResize()
        },
        getTableToResize () {
          let tables = document.getElementsByTagName('table')
  
          for (let i = 0; i < tables.length; i++) {
            this.resizableGrid(tables[i])
          }
        },
        resizableGrid (table) {
          let row = table.getElementsByTagName('tr')[0],
              cols = row ? row.children : undefined
          
          if (!cols) return
          
          table.style.overflow = 'hidden'
          
          let tableHeight = table.offsetHeight
          
          for (let i = 0; i < cols.length; i++) {
            let div = createDiv(tableHeight)
            cols[i].appendChild(div)
            cols[i].style.position = 'relative'
  
            setListeners(div)
          }
  
          function setListeners (div) {
            let pageX, curCol, nxtCol, curColWidth, nxtColWidth
  
            div.addEventListener('mousedown', e => {
              curCol = e.target.parentElement
              nxtCol = curCol.nextElementSibling
              pageX = e.pageX
              
              let padding = paddingDiff(curCol)
              
              curColWidth = curCol.offsetWidth - padding
  
              if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
            })
  
            div.addEventListener ('mouseover', e => {
              e.target.style.borderRight = '2px solid #e0e0e0'
            })
  
            div.addEventListener ('mouseout', e => {
              e.target.style.borderRight = ''
            })
  
            document.addEventListener ('mousemove', e => {
              if (curCol) {
                let diffX = e.pageX - pageX
            
                if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'
  
                curCol.style.width = (curColWidth + diffX)+'px'
              }
            })
  
            document.addEventListener ('mouseup', () => { 
              curCol = undefined
              nxtCol = undefined
              pageX = undefined
              nxtColWidth = undefined
              curColWidth = undefined
            })
          }
  
          function createDiv (height) {
            let div = document.createElement('div')
  
            div.style.top = 0
            div.style.right = 0
            div.style.width = '1px'
            div.style.position = 'absolute'
            div.style.cursor = 'col-resize'
            div.style.userSelect = 'none'
            div.style.height = height + 'px'
            div.style.background = '#e0e0e0'
  
            return div
          }
  
          function paddingDiff (col) {
            if (getStyleVal(col,'box-sizing') == 'border-box') {
              return 0
            }
            
            let padLeft = getStyleVal(col,'padding-left')
            let padRight = getStyleVal(col,'padding-right')
  
            return (parseInt(padLeft) + parseInt(padRight))
          }
  
          function getStyleVal (elm,css) {
            return (window.getComputedStyle(elm, null).getPropertyValue(css))
          }
        },

        reset (index) {
          if (this.$refs.form) this.$refs.form.reset()
          
          this.form = {
            id: index !== undefined ? index.id : '',
            par_id: index !== undefined ? index.par_id : '',
            category_id: index !== undefined ? index.category_id : '',
            satuan: index !== undefined ? index.satuan : '',
            name: index !== undefined ? index.name : '',
            type: index !== undefined ? index.type : 'layanan',
            image_url: index !== undefined ? index.image_url : '',
            stock: index !== undefined ? index.stock : '',
            stock_min: index !== undefined ? index.stock_min : '',
            selling_price: index !== undefined ? index.selling_price : '',
            hpp: index !== undefined ? index.hpp : '',
            duration_minutes: index !== undefined ? index.duration_minutes : '',
            discount_percent: index !== undefined ? index.discount_percent : '',
            discount_value: index !== undefined ? index.discount_value*1 : '',
            discount_type: index !== undefined ? index.discount_value > 0 ? 'rupiah' : index.discount_percent > 0 ? 'persen' : 'tidak' : 'tidak',
            is_ppn: index !== undefined ? index.is_ppn === '1' ? true : false : false,
            desc: index !== undefined ? index.desc : ''

          }

          this.process.form = false

          this.message.error = ''
        },

        resetSub (index) {
          if (this.$refs.form) this.$refs.form.reset()
          this.name_parent = index.name
          
          this.form = {
            id: '',
            par_id: index !== undefined ? index.id : '',
            category_id: index !== undefined ? index.category_id : '',
            satuan: '',
            name: `${index.name} `,
            type: 'layanan',
            image_url: '',
            stock: '',
            stock_min: '',
            selling_price: '',
            hpp: '',
            duration_minutes: '',
            discount_percent: '',
            discount_value: '',
            discount_type: 'tidak',
            is_ppn: false,
            desc: ''

          }

          this.process.form = false

          this.message.error = ''
        },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'pos/item_sales/add' : 'pos/item_sales/update'

          // SAVE TO REST API
          await post(url, {
            data: {
                id: this.form.id,
                outlet_id: this.outlet.outlet_id,
                par_id: this.form.par_id === '' || this.form.par_id === null ? '0' : this.form.par_id,
                category_id: this.form.category_id,
                satuan: this.form.satuan,
                name: this.form.name,
                type: this.form.type,
                image_url: this.form.image_url,
                stock: this.form.stock,
                stock_min: this.form.stock_min,
                selling_price: this.form.selling_price,
                hpp: this.form.hpp,
                duration_minutes: this.form.type === 'layanan' ? this.form.duration_minutes : '',
                discount_percent: this.form.discount_type === 'persen' ? this.form.discount_percent : this.form.discount_type === 'rupiah' ? (this.form.discount_value / this.form.selling_price) * 100 : 0,
                discount_value: this.form.discount_type === 'rupiah' ? this.form.discount_value : this.form.discount_type === 'persen' ? this.form.selling_price * (this.form.discount_percent / 100) : 0,
                is_ppn: this.form.is_ppn === true ? '1' : '0',
                desc: this.form.desc
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false
              this.dialog.formSub = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              

              if (this.form.id === '' && this.form.par_id === '0') {
                this.fetch()
              } else {
                if (this.selected_list === 'parent') {
                  this.fetch(this.paginationList)
                } else {
                  this.fetchLastChild(this.paginationList)
                }
              }


              if (this.selected_par_id === '0') {
                this.child = [
                  {
                    id: '0',
                    name: 'Data Produk',
                    link: true
                  }
                ]
              }
              this.reset()

            } else {
              this.message.error = res.message
              this.process.form = false
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
  
        toDelete (id) {
          this.selected.delete = [id]
  
          this.dialog.delete = true
        },
        async deletes () {
          this.message.error = ''
  
          this.process.delete = true
  
          await post(`pos/item_sales/delete`, {
            data: {
              id: this.selected.delete[0],
              outlet_id: this.outlet.outlet_id
            }
          }).then(response => {
            let res = response.data
  
            this.process.delete = false
  
            if (res.status === 200) {
  
              this.dialog.delete = false
  
              this.selected.row = []
              this.selected.delete = []
              
              this.dialog.snackbar = true
              this.message.success = res.message
  
              this.dialog.fullscreen = false
  
              if (this.selected_list === 'parent') {
                this.fetch(this.paginationList)
              } else {
                this.fetchLastChild(this.paginationList)
              }
            } else {
              this.message.error = res.message
            }
          })
        },
  
        async toStatus (val, index) {
          let url = val ? 'pos/user/activate' : 'pos/user/deactivate'
  
          await post(url, {
            data: {
              id: this.list[index].id
            }
          }).then(response => {
            let res = response.data
  
            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message
  
              this.fetch()
            }
          })
        },

      }
    }
  </script>


<style>
table, th, td {
/* border: 1px solid #ededed;
border-collapse: collapse; */
/* border: thin ridge black; */
border-spacing: 4px;
border-collapse: collapse;
}

.view {
margin: auto;
/* width: 100%; */
}

.wrapper-pegawai { 
overflow-y: auto; 
height: calc(100vh - 300px); 
} 

.wrapper-pegawai-none { 
/* overflow-y: auto; 
height: calc(100vh - 270px);  */
} 

.wrapper-pegawai th { 
position: sticky; 
top: 0; 
/* background-color: #080679 !important; */
} 
.sticky-col {
position: -webkit-sticky;
position: sticky;
/* background-color: #080679 !important; */
}

.one-col { background: #fff;
width: 60px;
min-width: 60px;
max-width: 60px;
left: 0px;
}

.second-col {
width: 150px;
min-width: 150px;
max-width: 150px;
left: 150px;
}

.three-col {
width: 150px;
min-width: 150px;
max-width: 150px;
left: 300px;
}

.four-col {
width: 200px;
min-width: 200px;
max-width: 200px;
left: 450px;
}

tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>